import { render } from "./rolemanagement.vue?vue&type=template&id=83298de6&scoped=true"
import script from "./rolemanagement.vue?vue&type=script&lang=js"
export * from "./rolemanagement.vue?vue&type=script&lang=js"

import "./rolemanagement.vue?vue&type=style&index=0&id=83298de6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-83298de6"

export default script